import { Link } from '@hub/common/Link/Link';
import { IconID } from '@hub/common/Icon/Icon';

interface FilterResetLinkProps {
  reset: () => void;
  dataTestId: string;
  text: string;
}

export const FilterResetLink = ({ reset, dataTestId, text }: FilterResetLinkProps) => (
  <Link
    dataTestId={dataTestId}
    className="text-left lf:text-right"
    onClick={() => {
      reset();
    }}
    primary={false}
    iconPrimary={false}
    text={text}
    icon={IconID.CLOSE_CROSS}
  />
);
